module.exports = __webpack_public_path__ + "img/close.c90c98dc.svg";